export const enum CreateClassRsvpError {
  RsvpExists = 'rsvp_exists',
  RsvpToPastEvent = 'rsvp_to_past_event',
}
